import React, { useContext, createContext } from "react";
import axiosFactory, { METHOD_POST, METHOD_GET } from "../helpers/AxiosFactory";
import {
  USER_LOGIN,
  USER_REGISTER,
  REFRESH,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from "../helpers/UrlConstants";

const AuthContext = createContext();
export function useAuthContext() {
  return useContext(AuthContext);
}

export default function AuthProvider({ children }) {
  async function Login(data) {
    return await axiosFactory({
      url: USER_LOGIN,
      method: METHOD_POST,
      data: data,
    });
  }
  async function Register(data) {
    return await axiosFactory({
      url: USER_REGISTER,
      method: METHOD_POST,
      data: data,
    });
  }
  async function Refresh() {
    return await axiosFactory({
      url: REFRESH,
      method: METHOD_GET,
    });
  }
  async function ForgotPassword(data) {
    return await axiosFactory({
      url: FORGOT_PASSWORD,
      method: METHOD_POST,
      data: data,
    });
  }
  async function ResetPassword(data) {
    return await axiosFactory({
      url: RESET_PASSWORD,
      method: METHOD_POST,
      data: data,
    });
  }
  const value = {
    Login,
    Register,
    Refresh,
    ForgotPassword,
    ResetPassword,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
